<template>
  <div class="AnswerCard">
      <div class="head">
        <p v-if="examend.isastrict == 1">考试用时：<span>{{examTime}}</span></p>
        <p v-if="examend.isastrict == 0">不限时</p>
      </div>
      <div class="card">
        <p class="name">答题卡 <span>{{getAnswerSheetInfoData.usecount}}/{{getAnswerSheetInfoData.allcount}}</span></p>
        <div class="btnlist">
          <div v-for="(item, index) in getAnswerSheetInfoData.answerkeysinfo" :key="index">
            <div @click="clickRefreshTestQuestions(index, item.innerid)">
              <template v-if="item.issubmit == 0">
                <div :class="{'btn': true, 'type-1': item.status == 1}">{{index + 1}}</div>
              </template>
              <template v-else>
                <div :class="{'btn': true, 'type-1': !item.answerstatus, 'type-2': item.answerstatus == 0, 'type-3': item.answerstatus == 1}">{{index + 1}}</div>
              </template>
            </div>
          </div>
        </div>
        <!-- end 答题卡选择区域 -->
        
        <div class="result" v-if="getAnswerSheetInfoData.issshow == 1 || examstatus == 1">
          <span class="status-error">错误</span>
          <span class="status-success">正确</span>
          <span class="status-none">未做</span>
        </div>
        <!-- end 答题结果 -->
        
        <div class="underway" v-if="examstatus == 0">
          <el-button type="primary" plain @click="preservationProgress">保存进度，下次继续</el-button>
          <el-button type="primary" @click="submitPapersPopu">提交试卷</el-button>
        </div>
        <!-- end 答题进行 -->
      </div>
  </div>
  <!-- end 答题卡 -->
</template>

<script>
import {mapActions} from 'vuex'
import {getAnswerSheetInfo} from 'api/questionbank'
import merge from 'webpack-merge'
export default {
  name: 'AnswerCard',
  props: ['examend', 'examstatus', 'pageinfo'], // 考试用时信息 是否提交试卷 pageinfo: {pageCount 最大页数 pageNum 当前页数 pageSize 每页显示条数 rowCount 题目总数}
  data () {
    return {
      exampid: this.$route.query.examid, // 考试id
      examTime: '00:00:00',  // 考试用时
      getAnswerSheetInfoData: {}  // 答题卡数据
    }
  },
  mounted () {
    this.getAnswerSheetInfo() // 获取答题卡数据接口
  },
  methods: {
    setExamTime(examTime) { // 设置考试用时
      this.examTime = examTime  
    },
    preservationProgress() {  // 保存进度
      this.$parent.startChildPreservationProgressPopu()
    },
    submitPapersPopu() {  // 提交试卷
      this.$parent.startChildSubmitPapersPopu()
    },
    getAnswerSheetInfo() {  // 答题卡数据接口
      this.setLoading(true)
      getAnswerSheetInfo({
        data: {exampid: this.exampid},
        success: data => {
          this.setLoading(false)
          this.getAnswerSheetInfoData = data.data
          console.log('答题卡数据接口', data)
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
    },
    clickRefreshTestQuestions(index, innerid) {  // 点击答题卡刷新试题列表 index 点击试题下标 innerid 试卷innerid

      let page = Math.floor(index / this.pageinfo.pageSize) + 1 // 换算页数 因初始为0 所以+1
      
      // 路由修改
      this.$router.push({
        query: merge(this.$route.query, {'page': page, 'innerid': innerid})
      })

    },
    ...mapActions(['setLoading'])
  },
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.AnswerCard {
  margin-top: 20px;
  .head {
    height: 50px;
    line-height: 50px;
    border-bottom: solid 1px #F8F8F8;
    background: #fff;
    p {
      padding-left: 73px;
      font-size: 16px;
      background: url('../../../../common/images/examination/icon-time.png') no-repeat;
      background-size: 20px;
      background-position-y: center;
      background-position-x: 45px;
      span {
        color: #F56C6C;
        font-size: 16px;
      }
    }
  }
  .card {
    padding: 17px 0px 19px 12px;
    box-sizing: border-box;
    background: #fff;
    .name {
      padding-bottom: 10px;
      font-size: 14px;
      font-weight: bold;
      span {
        margin-left: 12px;
        font-size: 14px;
        color: #409EFF;
      }
    }
    .btnlist {
        margin-left: -10px;
        overflow-y: auto;
        max-height: 262px;
        .btn {
          float: left;
          margin-top: 12px;
          margin-left: 10px;
          width:30px;
          height:30px;
          line-height: 28px;
          cursor: pointer;
          font-size: 12px;
          text-align: center;
          border:1px solid rgba(207,207,207,1);
          box-sizing: border-box;
          border-radius:2px;

          &.type-1 {
            background: #CFCFCF;
          }
          &.type-2 {
            color: #fff;
            border-color: #F56C6C;
            background: #F56C6C;
          }
          &.type-3 {
            color: #fff;
            border-color: #0ABF53;
            background: #0ABF53;
          }
        }
    }
    .result {
      margin-top: 30px;
      text-align: center;    

      span {
        position: relative;
        padding-right: 38px;
        
        &.status-none::before,
        &.status-success::before,
        &.status-error::before {
          content: '';
          position: absolute;
          margin: auto;
          right: 12px;
          top: 2px;
          bottom: 0;
          width: 18px;
          height: 18px;
        }
        &.status-error::before {
          content: '';
          background: #F56C6C;
        }
        &.status-none::before {
          content: '';
          border:1px solid rgba(207,207,207,1);
          box-sizing: border-box;
        }
        &.status-success::before {
          content: '';
          background: #0ABF53;
        }
        
      }
    }
    .underway {
      margin-top: 20px;
      .el-button {
        margin-bottom: 10px !important;
        width: 241px;
        margin: 0;
      }
    }
  
  }
}
</style>